import { useState } from "react";
import SignupTypeSelect from "./SignupTypeSelect";
import SignupAgreement from "./SignupAgreement";
import SignupMethod from "./SignupMethod";
import SignupNickname from "./SignupNickname";

export default function SignupPage() {
  const [step, setStep] = useState(0); // 0:유형, 1:동의, 2:방식, 3:정보입력
  const [userType, setUserType] = useState(""); // "fan" | "worker" | "artist"
  const [emailSignup, setEmailSignup] = useState(false); // 이메일 가입 플로우

  // 0: 유형 선택
  if (step === 0) {
    return (
      <SignupTypeSelect
        onSelect={type => {
          setUserType(type);
          setStep(1);
        }}
      />
    );
  }

  // 1: 개인정보동의
  if (step === 1) {
    return (
      <SignupAgreement
        userType={userType}
        onAgree={() => setStep(2)}
        onBack={() => setStep(0)}
      />
    );
  }

  // 2: 이메일/소셜 가입 방식 선택
  if (step === 2) {
    return (
      <SignupMethod
      userType={userType}
      onEmailSignupSuccess={() => { setEmailSignup(true); setStep(3); }}
      onSocialSignup={() => { setEmailSignup(false); setStep(3); }}
    />
    );
  }

  // 3: 추가 정보(닉네임) 입력
  if (step === 3) {
    return <SignupNickname />;
  }

  return null;
}
